var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-3" : "" },
        [
          _vm.loadingCollections
            ? _c(
                "div",
                { staticClass: "d-flex justify-center align-center py-8" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm.collectionsError
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.collectionsError) + " ")]
              )
            : _c(
                "div",
                { staticClass: "pitr-content" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        type: "warning",
                        outlined: "",
                        dense: "",
                        icon: "mdi-history",
                      },
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("pitr-title"))),
                      ]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v("— " + _vm._s(_vm.$t("pitr-description"))),
                      ]),
                    ]
                  ),
                  _c(
                    "v-form",
                    {
                      ref: "pitrForm",
                      model: {
                        value: _vm.formValid,
                        callback: function ($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid",
                      },
                    },
                    [
                      _c("v-autocomplete", {
                        staticClass: "mb-1",
                        attrs: {
                          items: _vm.collections,
                          label: _vm.$t("pitr-collection"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                          "prepend-inner-icon": "mdi-database",
                          placeholder: _vm.$t("pitr-select-collection"),
                        },
                        model: {
                          value: _vm.form.collection,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "collection", $$v)
                          },
                          expression: "form.collection",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-1",
                        attrs: {
                          label: _vm.$t("pitr-document-id"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                          "prepend-inner-icon": "mdi-identifier",
                          placeholder: _vm.$t("pitr-enter-document-id"),
                        },
                        model: {
                          value: _vm.form.documentId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "documentId", $$v)
                          },
                          expression: "form.documentId",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex align-start" },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            staticStyle: { flex: "1" },
                            attrs: {
                              label: _vm.$t("pitr-date-est"),
                              type: "date",
                              max: _vm.todayEST,
                              min: _vm.minDateEST,
                              rules: [_vm.rules.required],
                              outlined: "",
                              dense: "",
                              "prepend-inner-icon": "mdi-calendar",
                            },
                            model: {
                              value: _vm.form.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "date", $$v)
                              },
                              expression: "form.date",
                            },
                          }),
                          _c("v-text-field", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              label: _vm.$t("pitr-time-est"),
                              type: "time",
                              rules: [_vm.rules.required],
                              outlined: "",
                              dense: "",
                              "prepend-inner-icon": "mdi-clock-outline",
                            },
                            model: {
                              value: _vm.form.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "time", $$v)
                              },
                              expression: "form.time",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.timestampError
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                type: "error",
                                outlined: "",
                                dense: "",
                                icon: "mdi-alert-circle",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.timestampError) + " ")]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-4" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-3",
                              attrs: {
                                color: "primary",
                                loading: _vm.loadingPreview,
                                disabled: !_vm.canPreview,
                              },
                              on: { click: _vm.preview },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-eye"),
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("preview")) + " "),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "deep-orange",
                                dark: "",
                                loading: _vm.loadingWrite,
                                disabled: !_vm.canWrite,
                              },
                              on: { click: _vm.confirmWrite },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-restore"),
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.$t("pitr-write-restore")) + " "
                              ),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          _vm.previewData
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { text: "", small: "", color: "grey" },
                                  on: { click: _vm.clearPreview },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-close")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.$t("clear")) + " "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.previewData
                    ? _c("div", { staticClass: "preview-section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "preview-header d-flex align-center mb-2",
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: { small: "", color: "primary" },
                              },
                              [_vm._v("mdi-file-document-outline")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "font-weight-bold text-subtitle-2",
                              },
                              [_vm._v(_vm._s(_vm.$t("pitr-document-preview")))]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  "x-small": "",
                                  color: "primary",
                                  outlined: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.form.collection) +
                                    " / " +
                                    _vm._s(_vm.form.documentId) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ml-2",
                                attrs: { icon: "", "x-small": "" },
                                on: { click: _vm.copyPreviewData },
                              },
                              [
                                _c("v-icon", { attrs: { "x-small": "" } }, [
                                  _vm._v("mdi-content-copy"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "preview-body" }, [
                          _c("pre", { staticClass: "preview-json" }, [
                            _vm._v(_vm._s(_vm.formattedPreviewData)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.previewError
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-2",
                          attrs: {
                            type: "error",
                            outlined: "",
                            dense: "",
                            dismissible: "",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.previewError) + " ")]
                      )
                    : _vm._e(),
                  _vm.writeSuccess
                    ? _c(
                        "v-alert",
                        {
                          ref: "writeSuccessAlert",
                          staticClass: "mt-2",
                          attrs: {
                            type: "success",
                            outlined: "",
                            dense: "",
                            dismissible: "",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("pitr-document-restored")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.writeError
                    ? _c(
                        "v-alert",
                        {
                          ref: "writeErrorAlert",
                          staticClass: "mt-2",
                          attrs: {
                            type: "error",
                            outlined: "",
                            dense: "",
                            dismissible: "",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.writeError) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "450",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-4 px-2" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold pb-2" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "deep-orange" } },
                    [_vm._v("mdi-alert")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("pitr-confirm-restore")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mb-3" }),
              _c("v-card-text", [
                _c("p", { staticClass: "mb-2" }, [
                  _vm._v(" " + _vm._s(_vm.$t("pitr-overwrite-warning")) + " "),
                ]),
                _c("div", { staticClass: "confirm-details pa-3 mb-3" }, [
                  _c("div", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("pitr-collection")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.form.collection)),
                  ]),
                  _c("div", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("pitr-document-id")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.form.documentId)),
                  ]),
                  _c("div", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("pitr-timestamp-est")) + ":"),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.form.date) + " " + _vm._s(_vm.form.time)
                    ),
                  ]),
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "red--text text--darken-2 font-weight-medium mb-0",
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("pitr-action-cannot-be-undone")) + " "
                    ),
                  ]
                ),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "deep-orange",
                        dark: "",
                        loading: _vm.loadingWrite,
                      },
                      on: { click: _vm.write },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-restore"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("pitr-confirm-restore")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }